import { Services } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Buttons',

  mixins: [ proxy() ],

  props: {
    type: {
      type: String,
      default: undefined
    },

    tags: {
      type: Array,
      default: () => {
        return []
      }
    },

    customMenu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    maxButtons() {
      switch (this.type) {
        case SendingTypes.vk: return 10 // https://gitlab-y7r4iuqy1m.sigmasms.ru/sigma/issues/-/issues/1545
        case SendingTypes.whatsapp: return 3 // Изначально правило установленное больше 3х лет назад на текущий момент
      }
    },

    validationButtonUrl() {
      if (this.proxy.button.url && this.proxy.button.url.length > 2048) {
        return this.getTranslate(`${Services.sendings}.errors.button.url`)
      }
    },

    validationButtonText() {
      if (this.proxy.button.text && this.proxy.button.text.length > 30) {
        return this.getTranslate(`${Services.sendings}.errors.button.text`)
      }
    }
  },

  render
}
